import { render } from "./job_order.vue?vue&type=template&id=68c9c0a8&scoped=true"
import script from "./job_order.vue?vue&type=script&lang=js"
export * from "./job_order.vue?vue&type=script&lang=js"

import "./job_order.vue?vue&type=style&index=0&id=68c9c0a8&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c9c0a8"]])

export default __exports__